import React, { useState, Fragment, Component } from 'react';
import { ChevronDown, X, User, Menu, ShoppingCart } from 'lucide-react';
import { categoryData } from './CategoryDirectory';
export function ModernHeader() {
  const [showLogin, setShowLogin] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navLinks = [{
    name: 'HOME',
    href: '/'
  }, {
    name: 'ABOUT US',
    href: '/about'
  }, {
    name: 'SHIPPING',
    href: '/shipping'
  }, {
    name: 'SITEMAP',
    href: '/ProductCatalogSitemap.html'
  }, {
    name: 'MODEL CHARTS',
    href: '/model-charts'
  }, {
    name: 'CAREERS',
    href: '/careers'
  }, {
    name: 'CONTACT',
    href: '/contact'
  }];
  return <>
      {/* Top bar with tagline - NOT sticky, separate from header */}
      <div className="bg-gray-100 border-b border-gray-200" data-id="element-381">
        <div className="max-w-7xl mx-auto px-4 py-1.5" data-id="element-382">
          <p className="text-xs sm:text-sm text-gray-700 text-center font-medium" data-id="element-383">
            Nationwide Supplier of Industrial Bearings, Belts, Chain, Sprockets
            & Power Transmission Components
          </p>
        </div>
      </div>

      {/* Sticky header - white portion + nav */}
      <header className="sticky top-0 z-50 bg-white shadow-md" data-id="element-384">
        {/* Main header - reduced padding */}
        <div className="max-w-7xl mx-auto px-4 py-1 md:py-1.5" data-id="element-385">
          <div className="flex items-center justify-between gap-4" data-id="element-386">
            {/* Logo */}
            <a href="/" className="flex items-center gap-2 md:gap-3 flex-shrink-0" data-id="element-387">
              <img src="https://cdn.magicpatterns.com/uploads/2wR3tqwkt4Sj9e5DsXEEta/USABB-icon-logo.png" alt="USA Bearings & Belts Logo" className="w-12 h-12 md:w-16 md:h-16 object-contain flex-shrink-0" data-id="element-388" />
              <div data-id="element-389">
                <div className="text-lg md:text-xl font-bold leading-tight" data-id="element-390">
                  <span className="text-red-700" data-id="element-391">USA</span>{' '}
                  <span className="text-blue-800" data-id="element-392">Bearings & Belts</span>
                </div>
              </div>
            </a>

            {/* Search - Hidden on mobile, shown on md+ */}
            <div className="hidden md:block flex-1 max-w-xl" data-id="element-393">
              <div className="flex gap-2" data-id="element-394">
                <input type="text" placeholder="Search products..." className="flex-1 px-3 py-1.5 border border-gray-300 rounded text-sm" data-id="element-395" />
                <button className="bg-blue-800 text-white px-5 py-1.5 rounded font-semibold hover:bg-blue-900 text-sm" data-id="element-396">
                  Search
                </button>
              </div>
            </div>

            {/* Contact Info - Hidden on mobile */}
            <div className="hidden lg:block flex-shrink-0 text-right text-sm" data-id="element-397">
              <p className="text-gray-600" data-id="element-398">
                <strong data-id="element-399">Commercial Sales:</strong>{' '}
                <a href="tel:863-337-4984" className="text-lg font-bold text-gray-900 hover:text-red-700 transition-colors" data-id="element-400">
                  863-337-4984
                </a>
              </p>
              <p className="text-gray-600 text-xs" data-id="element-401">
                M-Fri 9:00-3:00 ET •{' '}
                <a href="mailto:sales@usabearingsandbelts.com" className="hover:text-blue-700 transition-colors" data-id="element-402">
                  sales@usabearingsandbelts.com
                </a>
              </p>
            </div>

            {/* Mobile menu button */}
            <button onClick={() => setShowMobileMenu(!showMobileMenu)} className="md:hidden p-2 text-gray-700" data-id="element-403">
              {showMobileMenu ? <X className="w-6 h-6" data-id="element-404" /> : <Menu className="w-6 h-6" data-id="element-405" />}
            </button>
          </div>

          {/* Mobile Search - Shown only on mobile */}
          <div className="mt-2 md:hidden" data-id="element-406">
            <div className="flex gap-2" data-id="element-407">
              <input type="text" placeholder="Search products..." className="flex-1 px-3 py-1.5 border border-gray-300 rounded text-sm" data-id="element-408" />
              <button className="bg-blue-800 text-white px-4 py-1.5 rounded font-semibold hover:bg-blue-900 text-sm" data-id="element-409">
                Search
              </button>
            </div>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:block bg-gray-800" data-id="element-410">
          <div className="max-w-7xl mx-auto px-4" data-id="element-411">
            <div className="flex items-center py-2" data-id="element-412">
              {/* Products Dropdown - Left Side */}
              <div className="relative" data-id="element-413">
                <button onClick={() => setShowProducts(!showProducts)} className="flex items-center gap-2 bg-red-700 text-white px-4 py-1.5 rounded font-semibold hover:bg-red-800 transition-colors mr-6 text-sm" data-id="element-414">
                  <span data-id="element-415">PRODUCTS</span>
                  <ChevronDown className={`w-4 h-4 transition-transform ${showProducts ? 'rotate-180' : ''}`} data-id="element-416" />
                </button>
              </div>

              {/* Main Nav Links - Center */}
              <div className="flex-1 flex items-center justify-center gap-1 flex-wrap" data-id="element-417">
                {navLinks.map((link, index, arr) => <Fragment key={link.name} data-id="element-418">
                    <a href={link.href} className="text-white text-sm font-medium hover:text-gray-300 px-2.5" data-id="element-419">
                      {link.name}
                    </a>
                    {index < arr.length - 1 && <span className="text-gray-500" data-id="element-420">|</span>}
                  </Fragment>)}
              </div>

              {/* Member Login - Right Side */}
              <div className="relative" data-id="element-421">
                <button onClick={() => setShowLogin(!showLogin)} className="flex items-center gap-1.5 text-white hover:text-gray-300 px-3 py-1.5 text-sm" data-id="element-422">
                  <User className="w-4 h-4" data-id="element-423" />
                  <span className="font-medium" data-id="element-424">Login</span>
                  <ChevronDown className={`w-3.5 h-3.5 transition-transform ${showLogin ? 'rotate-180' : ''}`} data-id="element-425" />
                </button>

                {/* Login Dropdown */}
                {showLogin && <div className="absolute right-0 top-full mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-xl z-50" data-id="element-426">
                    <div className="p-4" data-id="element-427">
                      <div className="flex items-center justify-between mb-4" data-id="element-428">
                        <h3 className="font-semibold text-gray-900" data-id="element-429">
                          Member Login
                        </h3>
                        <button onClick={() => setShowLogin(false)} className="text-gray-400 hover:text-gray-600" data-id="element-430">
                          <X className="w-5 h-5" data-id="element-431" />
                        </button>
                      </div>
                      <div className="space-y-3" data-id="element-432">
                        <div data-id="element-433">
                          <label htmlFor="login-email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-434">
                            Email
                          </label>
                          <input type="email" id="login-email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded" placeholder="your@email.com" data-id="element-435" />
                        </div>
                        <div data-id="element-436">
                          <label htmlFor="login-password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-437">
                            Password
                          </label>
                          <input type="password" id="login-password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded" placeholder="••••••••" data-id="element-438" />
                        </div>
                        <button className="w-full bg-blue-800 text-white px-4 py-2 rounded font-semibold hover:bg-blue-900" data-id="element-439">
                          Log In
                        </button>
                        <div className="flex justify-between text-sm" data-id="element-440">
                          <a href="#" className="text-blue-700 hover:underline" data-id="element-441">
                            Sign up
                          </a>
                          <a href="#" className="text-blue-700 hover:underline" data-id="element-442">
                            Forgot password?
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>

              {/* Cart - Right Side */}
              <a href="#" className="flex items-center gap-1.5 text-white hover:text-gray-300 px-3 py-1.5 relative text-sm" data-id="element-443">
                <ShoppingCart className="w-4 h-4" data-id="element-444" />
                <span className="font-medium" data-id="element-445">Cart</span>
                <span className="absolute -top-1 right-0 bg-red-600 text-white text-xs font-bold w-4 h-4 rounded-full flex items-center justify-center" data-id="element-446">
                  0
                </span>
              </a>
            </div>
          </div>
        </nav>

        {/* Mobile Navigation Menu */}
        {showMobileMenu && <div className="md:hidden bg-gray-800 border-t border-gray-700" data-id="element-447">
            <div className="px-4 py-4 space-y-2" data-id="element-448">
              {/* Products Button */}
              <button onClick={() => {
            setShowProducts(!showProducts);
            setShowMobileMenu(false);
          }} className="w-full flex items-center justify-between bg-red-700 text-white px-4 py-3 rounded font-semibold" data-id="element-449">
                <span data-id="element-450">PRODUCTS</span>
                <ChevronDown className="w-5 h-5" data-id="element-451" />
              </button>

              {/* Nav Links */}
              {navLinks.map(link => <a key={link.name} href={link.href} className="block text-white text-sm font-medium px-4 py-3 hover:bg-gray-700 rounded" data-id="element-452">
                  {link.name}
                </a>)}

              {/* Member Login */}
              <button onClick={() => {
            setShowLogin(!showLogin);
            setShowMobileMenu(false);
          }} className="w-full flex items-center gap-2 text-white px-4 py-3 hover:bg-gray-700 rounded" data-id="element-453">
                <User className="w-5 h-5" data-id="element-454" />
                <span className="text-sm font-medium" data-id="element-455">Member Login</span>
              </button>

              {/* Cart */}
              <a href="#" className="flex items-center gap-2 text-white px-4 py-3 hover:bg-gray-700 rounded" data-id="element-456">
                <ShoppingCart className="w-5 h-5" data-id="element-457" />
                <span className="text-sm font-medium" data-id="element-458">Cart (0)</span>
              </a>

              {/* Contact Info */}
              <div className="border-t border-gray-700 pt-4 mt-4 text-sm text-gray-300 space-y-2 px-4" data-id="element-459">
                <p data-id="element-460">
                  <strong data-id="element-461">Phone:</strong>{' '}
                  <a href="tel:863-337-4984" className="hover:text-white transition-colors" data-id="element-462">
                    863-337-4984
                  </a>
                </p>
                <p data-id="element-463">
                  <strong data-id="element-464">Hours:</strong> M-Fri 9:00-3:00 ET
                </p>
                <p data-id="element-465">
                  <strong data-id="element-466">Email:</strong>{' '}
                  <a href="mailto:sales@usabearingsandbelts.com" className="hover:text-white transition-colors" data-id="element-467">
                    sales@usabearingsandbelts.com
                  </a>
                </p>
              </div>
            </div>
          </div>}

        {/* Products Mega Menu - Compact catalog-style */}
        {showProducts && <>
            {/* Backdrop */}
            <div className="fixed inset-0 bg-black/30 z-40" onClick={() => setShowProducts(false)} data-id="element-468" />

            {/* Mega Menu Panel */}
            <div className="absolute left-0 right-0 bg-white border-b-4 border-red-700 shadow-2xl z-50 max-h-[80vh] overflow-y-auto" data-id="element-469">
              <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-470">
                <div className="flex items-center justify-between mb-3" data-id="element-471">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-472">
                    All Product Categories
                  </h3>
                  <button onClick={() => setShowProducts(false)} className="p-1.5 hover:bg-gray-100 rounded-full" data-id="element-473">
                    <X className="w-5 h-5 text-gray-600" data-id="element-474" />
                  </button>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-6 gap-y-4" data-id="element-475">
                  {categoryData.map(group => <div key={group.title} className="border-l-2 border-red-600 pl-3" data-id="element-476">
                      <h4 className="font-semibold text-gray-900 text-sm mb-1.5" data-id="element-477">
                        {group.title}
                      </h4>
                      <ul className="space-y-0.5" data-id="element-478">
                        {group.categories.map(category => <li key={category.url} data-id="element-479">
                            <a href={category.url} className="text-blue-700 hover:text-blue-900 hover:underline text-xs leading-tight block py-0.5" onClick={() => setShowProducts(false)} data-id="element-480">
                              {category.name}
                            </a>
                          </li>)}
                      </ul>
                    </div>)}
                </div>
              </div>
            </div>
          </>}
      </header>

      {/* Mobile Login Panel */}
      {showLogin && <div className="md:hidden fixed inset-0 bg-black/50 z-[60]" onClick={() => setShowLogin(false)} data-id="element-481">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-sm bg-white rounded-lg shadow-xl" onClick={e => e.stopPropagation()} data-id="element-482">
            <div className="p-5" data-id="element-483">
              <div className="flex items-center justify-between mb-4" data-id="element-484">
                <h3 className="font-semibold text-gray-900 text-lg" data-id="element-485">
                  Member Login
                </h3>
                <button onClick={() => setShowLogin(false)} className="text-gray-400 hover:text-gray-600" data-id="element-486">
                  <X className="w-6 h-6" data-id="element-487" />
                </button>
              </div>
              <div className="space-y-4" data-id="element-488">
                <div data-id="element-489">
                  <label htmlFor="mobile-login-email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-490">
                    Email
                  </label>
                  <input type="email" id="mobile-login-email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-3 py-3 border border-gray-300 rounded text-base" placeholder="your@email.com" data-id="element-491" />
                </div>
                <div data-id="element-492">
                  <label htmlFor="mobile-login-password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-493">
                    Password
                  </label>
                  <input type="password" id="mobile-login-password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-3 py-3 border border-gray-300 rounded text-base" placeholder="••••••••" data-id="element-494" />
                </div>
                <button className="w-full bg-blue-800 text-white px-4 py-3 rounded font-semibold hover:bg-blue-900" data-id="element-495">
                  Log In
                </button>
                <div className="flex justify-between text-sm" data-id="element-496">
                  <a href="#" className="text-blue-700 hover:underline" data-id="element-497">
                    Sign up
                  </a>
                  <a href="#" className="text-blue-700 hover:underline" data-id="element-498">
                    Forgot password?
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </>;
}